import { I18N } from "../i18n.js";

const LANGUAGE = "en";

export default class HotspotsManager {
  /**
   * @param {import("Spinner.js").Spinner} spinner
   */
  constructor(spinner) {
    this.spinner = spinner;
    this.layer = spinner.hotspotsLayer;
    this.buttons = {};
    this.labels = [];
  }

  /**
   * Renders the hotspots based on the provided features.
   * @param {object} features
   */
  render(features) {
    for (const slug in features) {
      if (!this.labels.includes(slug)) continue;

      const [x, y] = features[slug];
      let button = this.buttons[slug];
      if (!button) {
        button = document.createElement("button");
        button.className = "hotspot";
        button.innerHTML =
          '<span class="pulse"></span><span class="dot"></span>';
        button.dataset.slug = slug;
        button.title = I18N[LANGUAGE][slug];
        button.onclick = () => {
          if (this.spinner.carouselLayer.isOpen) {
            return;
          }

          this.onHotspotClick(button).catch(console.error);
        };

        this.buttons[slug] = button;
        this.layer.appendToSubject(button);
      }

      button.style.cssText = `left: ${x}%; top: ${y}%`;
    }

    // Append and remove buttons based on their availability in features list
    for (const slug in this.buttons) {
      const button = this.buttons[slug];
      if (!Object.prototype.hasOwnProperty.call(features, slug)) {
        button.style.opacity = "0";
      } else {
        button.style.opacity = "1";
      }
    }
  }

  /**
   * Handles the hotspot click event.
   * @param {HTMLButtonElement} hotspot
   * @returns {Promise<void>}
   */
  async onHotspotClick(hotspot) {
    const selectedHotspot = this.spinner.intellicrops[hotspot.dataset.slug];

    await this.spinner.showCarousel(
      selectedHotspot,
      hotspot.getBoundingClientRect(),
    );
  }

  /**
   * Clears all hotspots.
   */
  clear() {
    this.layer.subject.innerHTML = "";
    this.buttons = {};
  }

  /**
   * Resets the hotspots with new labels.
   * @param {string[]} labels
   */
  setLabels(labels) {
    this.clear();
    this.labels = labels;
  }
}
